



































import Api from "@/api/Api";
import _ from "lodash";
import Vue, { PropType } from "vue";

type ModifyQueryInterface = (
  arg0: Record<string, string | number>
) => Record<string, string | number>;
export default Vue.extend({
  props: {
    resource: String,
    itemsPerPage: {
      type: Number,
      default: 20,
    },
    modifyQuery: {
      type: Function as PropType<ModifyQueryInterface>,
      default: (v) => v,
    },
    baseQuery: {
      type: Object,
    },
    defaultSortField: String,
    defaultSortOrder: {
      type: String,
      default: "asc",
    },
    filters: {
      type: Object as PropType<Record<string, string | number>>,
    },
  },
  data() {
    return {
      sortField: null as string | null,
      sortOrder: null as string | null,
      page: 1,
      items: [],
      total: null as number | null,
      loading: false,
    };
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await Api.singleton().call({
        method: "GET",
        resource: this.resource,
        query: this.buildQuery(
          this.sortField,
          this.sortOrder,
          this.page,
          this.itemsPerPage
        ),
      });

      this.items = res["hydra:member"];
      this.total = res["hydra:totalItems"];
      this.loading = false;
    },
    buildQuery(
      sortField: string | null,
      sortOrder: string | null,
      page: number,
      itemsPerPage: number
    ) {
      const query = {} as { [key: string]: string | number };
      query.page = page;
      query.itemsPerPage = itemsPerPage;

      if (this.baseQuery) {
        _.assign(query, this.baseQuery);
      }
      if (sortField !== null) {
        query["order[" + sortField + "]"] = sortOrder || "asc";
      } else if (this.defaultSortField !== null) {
        query["order[" + this.defaultSortField + "]"] =
          sortOrder || this.defaultSortOrder || "asc";
      }

      return this.modifyQuery(query);
    },
    onFilterChange: _.debounce(function(this: any) {
      this.fetch();
    }, 200),
    onPageChange(page: number) {
      this.page = page;
      this.fetch();
    },
    onSort(field: string, order: string) {
      this.sortField = field;
      this.sortOrder = order;
      this.fetch();
    },
  },
  mounted() {
    this.fetch();
  },
  watch: {
    $route() {
      this.fetch();
    },
    filters: {
      handler() {
        this.onFilterChange();
      },
      deep: true,
    },
    loading() {
      this.$emit("loadingStateChange", this.loading);
    },
  },
});
